import React from "react";
import { useTranslation } from "react-i18next";

import ToggleSwitch from "components/uiComponents/ToggleSwitch";

import { ReactComponent as TranslateBase } from "static/icons/translate-base.svg";
import { ReactComponent as QuestionCircle } from "static/icons/question-circle.svg";

import "./TranslateModel.scss";

const TranslateModel = ({ isActive, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className="translate-model-container">
      <div className="translate-model-container__content">
        <TranslateBase />

        <span>{t("translate_model")}</span>

        <QuestionCircle />
      </div>

      <ToggleSwitch
        id="translate-model"
        checked={isActive}
        onChange={onChange}
        small
      />
    </div>
  );
};

export default TranslateModel;
